import { Component, HostBinding, Input } from '@angular/core';

export type EmptyStateType = 'noData' | 'noResults' | 'success' | 'error';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    standalone: false,
})
export class EmptyStateComponent {
    @HostBinding('class') componentClass = 'wrap-empty-state-container';

    @Input() public type: EmptyStateType;
    @Input() public title: string;
    @Input() public subtitle: string;
    @Input() public className = '';

    constructor() {}

    public getSrcImage(): string {
        switch (this.type) {
            case 'noResults':
                return 'assets/images/illustrations/no_results.svg';
            case 'noData':
                return 'assets/images/illustrations/no_data.svg';
            case 'success':
                return 'assets/images/illustrations/accomplishment.svg';
            case 'error':
                return 'assets/images/illustrations/error.svg';
            default:
                return '';
        }
    }
}
